import axios from 'axios'
import { APP_API_BASE } from '@/utils/api-base'

const publicRequest = axios.create({
  baseURL: APP_API_BASE,
  timeout: 15000
})

function unwrap(res) {
  const body = res && res.data
  if (!body) {
    return Promise.reject(new Error('网络异常'))
  }
  if (body.status != null && Number(body.status) !== 200) {
    return Promise.reject(new Error(body.msg || body.message || '请求失败'))
  }
  return body.data
}

/** 公开库存看板 */
export function fetchPublicSealStockBoard(token) {
  return publicRequest
    .get('/signstore/public/sealStock/board', { params: { token } })
    .then(unwrap)
}
